import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./student.css";
const { readCookie } = require("../../Functions/Cookies.js");

function StudentInfo() {
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("#34sasdsdsadasds");
  const [expiryDate, setExpiryDate] = useState("");
  const [signUpDate, setSignUpDate] = useState("");
  const [classOptions, setClassOptions] = useState([]);
  const [studentClass, setStudentClass] = useState("");
  const [studentSection, setStudentSection] = useState("");
  const [allSection, setAllSection] = useState([]);
  const [prev, setPrev] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  const studentId = localStorage.getItem("studentId");

  // Toast messages
  const showToastSuccess = (msg) => toast.success(msg);
  const showToastError = (msg) => toast.error(msg);

  const handleEdit = () => {
    setPrev({ name, contact, email, expiryDate, studentClass, studentSection });
    setIsEditing(true);
    setPassword(""); // clear password when editing
  };

  const handleSave = async () => {
    if (!isEditing) return;

    let obj = {};
    if (prev.name !== name) obj.name = name;
    if (prev.email !== email) obj.email = email;
    if (prev.contact !== contact) obj.contact = contact;
    if (prev.expiryDate !== expiryDate) obj.expiryDate = expiryDate;
    if (prev.studentClass !== studentClass) obj.grade = studentClass;
    if (prev.studentSection !== studentSection) obj.section = studentSection;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_ORIGIN}/api/v1/students/${studentId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            token: readCookie("token"),
          },
          body: JSON.stringify({ ...obj, password }),
        }
      );
      const data = await res.json();
      if (data.status !== "success") throw new Error(data.message);

      // refetch student info after update
      await fetchStudentData();
      setIsEditing(false);
      showToastSuccess("Details Updated!!");
    } catch (err) {
      showToastError(err.message || "Error updating details");
    }
  };

  const fetchStudentData = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_ORIGIN}/api/v1/students/${studentId}`,
      {
        headers: {
          token: readCookie("token"),
        },
      }
    );
    const data = await res.json();
    const s = data.data.student;
    setName(s.name);
    setEmail(s.email);
    setContact(s.contact);
    setExpiryDate(s.expiryDate.split("T")[0]);
    setSignUpDate(s.signUpDate.split("T")[0]);
    setStudentClass(s.grade);
    setStudentSection(s.section);
    setPassword("#34sasdsdsadasds"); // reset hidden password
  };

  const fetchClassOptions = async () => {
    const schoolId = localStorage.getItem("schoolsId");
    const res = await fetch(
      `${process.env.REACT_APP_ORIGIN}/api/v1/grades?schoolId=${schoolId}&fields=sections,grade,subjects`,
      {
        headers: { token: readCookie("token") },
      }
    );
    const data = await res.json();
    const grades = data.data.grades;
    setClassOptions(grades.map((g) => g.grade));
    localStorage.setItem("allOptions", JSON.stringify(grades));
  };

  const setSectionsForClass = (grade) => {
    const gradesArray = JSON.parse(localStorage.getItem("allOptions") || "[]");
    const gradeObj = gradesArray.find((g) => g.grade === grade);
    if (gradeObj) {
      setAllSection(
        gradeObj.sections.map((sec) => ({
          value: sec._id,
          label: sec.section,
        }))
      );
    }
  };

  useEffect(() => {
    fetchStudentData();
    fetchClassOptions();
  }, []);

  useEffect(() => {
    setSectionsForClass(studentClass);
  }, [studentClass]);

  return (
    <div
      id="studentInfo"
      className="Student_right_side_bottom_right_info VerticalTabs"
    >
      <ToastContainer />
      <div className="rightSchoolDetails">
        {/* Name + Class/Section */}
        <div className="rightSchoolDetails-upper">
          <div className="rightSchoolDetails-upper-left">
            <label>Name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Student Name"
              disabled={!isEditing}
            />
          </div>
          <div className="rightSchoolDetails-upper-right">
            <div>
              <label>Class</label>
              <select
                value={studentClass}
                onChange={(e) => setStudentClass(e.target.value)}
                disabled={!isEditing}
              >
                <option value="">Select Class</option>
                {classOptions.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label>Sections</label>
              <select
                value={studentSection}
                onChange={(e) => setStudentSection(e.target.value)}
                disabled={!isEditing}
              >
                <option value="">Select Section</option>
                {allSection.map((item) => (
                  <option key={item.value} value={item.label}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Email + Contact */}
        <div className="rightSchoolDetails-lower">
          <div className="rightSchoolDetails-lower-left">
            <label>Email</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={!isEditing}
            />
          </div>
          <div className="rightSchoolDetails-lower-right">
            <label>Contact</label>
            <input
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              disabled={!isEditing}
            />
          </div>
        </div>

        {/* Password */}
        <div className="rightSchoolDetails-lower" style={{ marginTop: "30px" }}>
          <div className="rightSchoolDetails-lower-left">
            <label>Password</label>
            <input
              type={isEditing ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={!isEditing}
            />
          </div>
        </div>

        {/* Dates */}
        <div className="rightSchoolDetails-lower" style={{ marginTop: "30px" }}>
          <div className="rightSchoolDetails-lower-left">
            <label>Expiry Date</label>
            <input
              type="date"
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
              disabled={!isEditing}
            />
          </div>
          <div className="rightSchoolDetails-lower-right">
            <label>SignUp Date</label>
            <input type="date" value={signUpDate} disabled />
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div
        className="edit_save_button"
        style={{ marginTop: "60px", marginBottom: "100px" }}
      >
        {!isEditing ? (
          <div className="edit_button">
            <button onClick={handleEdit}>Edit</button>
          </div>
        ) : (
          <div className="save_button" onClick={handleSave}>
            <button>Save </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default StudentInfo;
